import { render, staticRenderFns } from "./SelectDepartModel.vue?vue&type=template&id=2e9da43a&scoped=true"
import script from "./SelectDepartModel.vue?vue&type=script&lang=js"
export * from "./SelectDepartModel.vue?vue&type=script&lang=js"
import style0 from "./SelectDepartModel.vue?vue&type=style&index=0&id=2e9da43a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9da43a",
  null
  
)

export default component.exports